const META_NAME = 'pethernity-api-base';
const META_PLACEHOLDER = '__PETAPI__';

function readApiBaseFromMeta(): string {
  if (typeof document === 'undefined') return '';
  const el = document.querySelector(`meta[name="${META_NAME}"]`);
  const v = el?.getAttribute('content')?.trim() ?? '';
  if (!v || v === META_PLACEHOLDER) return '';
  return v.replace(/\/$/, '');
}

const fromMeta = readApiBaseFromMeta();
const viteRaw = import.meta.env.VITE_API_URL;
const fromVite = typeof viteRaw === 'string' ? viteRaw.trim().replace(/\/$/, '') : '';

/**
 * Prefer HTML meta (runtime inject) over Vite inline, so Cloud Run can fix a bad build without rebuilding JS.
 * In production the Docker image serves a same-origin /api reverse proxy by default; this keeps auth cookies
 * first-party for Safari/iOS/private browsing.
 */
const defaultApiBase = import.meta.env.PROD ? '/api' : 'http://localhost:3030';
const resolved = fromMeta || fromVite || defaultApiBase;

const localhostPattern = /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/;

if (import.meta.env.PROD) {
  if (localhostPattern.test(resolved)) {
    throw new Error(
      'Production is still pointing at localhost for API calls. On the frontend Cloud Run service set ' +
        'PUBLIC_API_BASE_URL=/api and API_UPSTREAM=https://<your-backend-host>, or rebuild with ' +
        'VITE_API_URL=/api. Direct browser calls to a separate API origin can break auth cookies on Safari/iOS.'
    );
  }
}

export const apiBaseUrl = resolved;
